import { styled } from "../stitches";

const Typography = styled("p", {});

export default Typography;
